import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzSelectModule } from '@blk/daisy/combinations/dropdown';
import { AnalyticsModule } from '@ddt-web/analytics';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';

import { ProposalMetricsComponent } from './components/proposal-metrics/proposal-metrics.component';
import { ProposalPurposeComponent } from './components/proposal-purpose/proposal-purpose.component';

@NgModule({
	imports: [
		CommonModule,
		CwpNgFrameworkModule,
		AnalyticsModule,
		GenericDirectivesModule,
		DzSelectModule
	],
	declarations: [
		ProposalMetricsComponent,
		ProposalPurposeComponent
	],
	exports: [
		ProposalMetricsComponent,
		ProposalPurposeComponent
	],
	providers: [
		// should add the proposal service?
	]
})
export class ProposalModule { }
